export default function Hero() {
  return (
    <section 
      id="hero" 
      className="relative min-h-screen flex items-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(30, 58, 138, 0.95) 0%, rgba(30, 58, 138, 0.85) 40%, rgba(30, 58, 138, 0.3) 70%, transparent 100%), url('https://readdy.ai/api/search-image?query=Large%20scale%20construction%20materials%20trade%20fair%20exhibition%20in%20China%20with%20massive%20modern%20convention%20center%20halls%20filled%20with%20professional%20booths%20displaying%20building%20materials%2C%20ceramic%20tiles%2C%20marble%20samples%2C%20construction%20equipment%2C%20and%20international%20business%20professionals%20networking%20in%20a%20bustling%20commercial%20environment%20with%20bright%20industrial%20lighting%20and%20organized%20exhibition%20stands%20showcasing%20premium%20construction%20products&width=1920&height=1080&seq=hero-china-fair-002&orientation=landscape')`
      }}
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-2xl">
          <div className="inline-block bg-blue-100 text-blue-900 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-shield-check-line mr-2"></i>
            Acceso Exclusivo a Profesionales B2B
          </div>
          
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Importación Directa de Materiales de Construcción Premium
          </h2>
          
          <p className="text-xl text-blue-50 mb-8 leading-relaxed">
            Conectamos a profesionales españoles con los mejores fabricantes chinos. Soluciones integrales para arquitectos, interioristas y constructoras que buscan calidad, precio competitivo y servicio personalizado.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <button 
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-white text-blue-900 px-8 py-4 rounded-lg font-semibold hover:bg-blue-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line mr-2"></i>
              Solicitar Información
            </button>
            <button 
              onClick={() => document.getElementById('catalog')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-blue-800 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-all border-2 border-white/30 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-folder-open-line mr-2"></i>
              Ver Catálogo B2B
            </button>
          </div>

          <div className="grid grid-cols-3 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
              <div className="text-3xl font-bold text-white mb-1">10+</div>
              <div className="text-sm text-blue-100">Años de Experiencia</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
              <div className="text-3xl font-bold text-white mb-1">100+</div>
              <div className="text-sm text-blue-100">Proyectos Completados</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
              <div className="text-3xl font-bold text-white mb-1">98%</div>
              <div className="text-sm text-blue-100">Satisfacción Cliente</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white"></i>
      </div>
    </section>
  );
}
